import BunkeyAPI from '../api/BunkeyAPI'
import { sendNotification } from '../utils';
import {
  PLAN_SERVICES_GET_DATA,
  PLAN_SERVICES_GET_DATA_FAILURE,
  PLAN_SERVICES_GET_DATA_SUCCESS,
  PLAN_SERVICES_SEND,
  PLAN_SERVICES_SEND_FAILURE,
  PLAN_SERVICES_SEND_SUCCESS,
  PLAN_SERVICES_BY_USER,
  PLAN_SERVICES_BY_USER_SUCCESS,
  PLAN_SERVICES_BY_USER_FAILURE,
  PLAN_SERVICES_BY_USER_UPDATE,
  PLAN_SERVICES_BY_USER_SUCCESS_UPDATE,
  PLAN_SERVICES_BY_USER_FAILURE_UPDATE,
  UPDATE_PLAN_LINK_GENERATE,
  UPDATE_PLAN_LINK_GENERATE_SUCCESS,
  UPDATE_PLAN_LINK_GENERATE_ERROR,
  REDUCE_PLAN,
  REDUCE_PLAN_ERROR,
  REDUCE_PLAN_SUCCESS
} from "../constants/plan-services-types";

export const getPlanServices = (isFetching = true, data = []) => {
  return dispatch => {
    dispatch({
      type: PLAN_SERVICES_GET_DATA,
      payload: {
        isFetching,
        data,
      }
    })
    BunkeyAPI({
      url: `/clients/service/planservice`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: PLAN_SERVICES_GET_DATA_SUCCESS,
        payload: {
          data: resp.data
            .map(r => {
              return {
                ...r,
                key: r._id,
                qty: 0,
                buy: true,
              }
            }),
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: PLAN_SERVICES_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}

export const sendPlanServicesByClient = (workclient, data = [], intl) => {
  return dispatch => {
    dispatch({ type: PLAN_SERVICES_SEND })

    BunkeyAPI({
      url: `/admin/createRecord/${workclient}`,
      method: 'POST',
      data: {
        modules: data.map(item => ({idService: item._id, quantity: item.qty})),
      }
    }).then(resp => {
      dispatch({
        type: PLAN_SERVICES_SEND_SUCCESS,
        payload: {
          headers: resp.headers
        }
      })
      sendNotification('success', intl, intl.formatMessage({ id: 'plan_has_been_updated' }))
    }).catch(err => {
      dispatch({
        type: PLAN_SERVICES_SEND_FAILURE,
        payload: err
      })
      sendNotification('error', intl, intl.formatMessage({ id: 'plan_hasnt_been_updated' }))
    })
  }
}
export const getPlanServicesByUser = (workclient) => {
  return dispatch => {
    dispatch({ type: PLAN_SERVICES_BY_USER })
    BunkeyAPI({
      url: `/admin/getRecord/${workclient}`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: PLAN_SERVICES_BY_USER_SUCCESS,
        payload: {
          modules: resp.data.modules
        }
      })
    }).catch(err => {
      dispatch({
        type: PLAN_SERVICES_BY_USER_FAILURE,
        payload: err
      })
    })
  }
}
export const updatePlanServicesByUser = (workclient, userPacks, intl) => {
  return dispatch => {
    dispatch({ type: PLAN_SERVICES_BY_USER_UPDATE })

    BunkeyAPI({
      url: `/admin/createRecord/${workclient}`,
      method: 'POST',
      data: {
        modules: userPacks.map(e => ({
          "idService": e._id,
          "quantity": e.quantity
        }))
      }
    }).then(resp => {
      dispatch({
        type: PLAN_SERVICES_BY_USER_SUCCESS_UPDATE,
        payload: {
          modules: userPacks
        }
      });
      sendNotification('success', intl, intl.formatMessage({ id: 'plan_has_been_updated' }))
    }).catch(err => {
      dispatch({
        type: PLAN_SERVICES_BY_USER_FAILURE_UPDATE,
        payload: err
      });
      sendNotification('error', intl, intl.formatMessage({ id: 'asset_could_not_share' }))
    })
  }
}
export const updatePlanLinkGenerate = (workclient, amount, intl, modules) => {
  return dispatch => {
    dispatch({ type: UPDATE_PLAN_LINK_GENERATE });
    BunkeyAPI({
      url: `/clients/${workclient}/subscription/plan`,
      method: 'PUT',
      data: {
        amount: amount,
        modules: modules
      }
    }).then(resp => {
      dispatch({
        type: UPDATE_PLAN_LINK_GENERATE_SUCCESS,
        payload: {
          link: resp.data.redirect_url
        }
      });
      sendNotification('success', intl, intl.formatMessage({ id: 'payment-update-success' }))
    }).catch(err => {
      dispatch({
        type: UPDATE_PLAN_LINK_GENERATE_ERROR,
        payload: err
      });
      sendNotification('error', intl, intl.formatMessage({ id: 'payment-update-error' }))
    })
  }
}
export const reducePlan = (workclient, amount, intl) => {
  return dispatch => {
    dispatch({ type: REDUCE_PLAN })

    BunkeyAPI({
      url: `/clients/${workclient}/subscription/plan/reduce`,
      method: 'PUT',
      data: {
        amount: amount
      }
    }).then(resp => {
      dispatch({
        type: REDUCE_PLAN_SUCCESS,
        payload: {
          
        }
      });
      sendNotification('success', intl, intl.formatMessage({ id: 'payment_reduce_success' }))
    }).catch(err => {
      dispatch({
        type: REDUCE_PLAN_ERROR,
        payload: err
      });
      sendNotification('error', intl, intl.formatMessage({ id: 'payment_reduce_error' }))
    })
  }
}
